// src/components/GlobalBackgroundVideo.jsx
import React, { useState, useEffect } from 'react';

/**
 * Componente de Fondo Global con Columnas de Cadenas Animadas
 * Repetidas horizontal y verticalmente cubriendo toda la pantalla.
 * Fondo base color institucional #c61f23.
 * Movimiento continuo en direcciones opuestas para emular el video oficial:
 * - Columnas impares: hacia abajo (1.5s)
 * - Columnas pares: hacia arriba (1.7s)
 *
 * @param {Object} props
 * @param {boolean} [props.showOverlay=true] - Capa de oscurecimiento muy ligera para elevar el contraste y legibilidad.
 */
export default function GlobalBackgroundVideo({ showOverlay = true }) {
  const [columns, setColumns] = useState(() => {
    const width = typeof window !== 'undefined' ? window.innerWidth : 1200;
    const colWidth = width < 768 ? 120 : 160;
    const count = Math.max(3, Math.ceil(width / colWidth));
    return Array.from({ length: count });
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const colWidth = width < 768 ? 120 : 160;
      const count = Math.max(3, Math.ceil(width / colWidth));
      setColumns(Array.from({ length: count }));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className="hero-video-wrapper global-video-background position-fixed top-0 start-0 w-100 h-100"
      style={{
        backgroundColor: '#c61f23',
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden'
      }}
      aria-hidden="true"
    >
      {/* Columnas continuas de cadenas cubriendo todo el ancho y alto */}
      <div className="chains-background-container position-absolute top-0 start-0 w-100 h-100" data-testid="chains-container">
        {columns.map((_, index) => {
          const isEven = index % 2 === 0;
          return (
            <div
              key={index}
              className={`chain-column-strip ${isEven ? 'chain-column-even' : 'chain-column-odd'}`}
              style={{
                backgroundImage: "url('/img/page/cadena-xolofest-interaktia.png')",
                animationDelay: `${(index % 4) * -0.4}s`
              }}
            />
          );
        })}
      </div>

      {/* Capa de oscurecimiento muy ligera para elevar el contraste y legibilidad del texto */}
      {showOverlay && (
        <div className="hero-video-overlay"></div>
      )}
    </div>
  );
}
